import React from "react";
import PropTypes from "prop-types";
import { Grid, TextField, Button } from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import { withStyles } from "@material-ui/core/styles";
import DialogTitle from "@material-ui/core/DialogTitle";
import AbstractUserList from "./containers/AbstractUserList";
import UserGroupStore from "../stores/UserGroupStore";
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import MessageAction from './MessageAction';

const style = {
  close:{
    position: "absolute",
    right:  9,
    top: 15
  },
  placeholder:{
    fontWeight: 'normal'
  }
};

class UserGroupDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ...props.group,
      saveMessage: '',
      users_section: false,
      current_name: this.props.group.short_name,
      showMessage: false,
      type: ''
    };
  }

  componentDidUpdate(prevProps,prevState) {
    if(this.props.group.id !== prevProps.group.id ||
       this.props.group.job_title !== prevProps.group.job_title ){
      this.setState({
        id: this.props.group.id,
        job_title: this.props.group.job_title,
        long_name: this.props.group.long_name,
        short_name: this.props.group.short_name,
        name: {full: this.props.group.name.full, title: this.props.group.name.title},
      });
    }
  }

  onChangeName = (value, field) => {
    this.setState(ps => {
      const ns = { ...ps };
      ns[field] = value;
      this.props.onChange({ ...ns, id: this.props.group.id });
      return ns;
    });
  };

  onCreate = () => {
    const data = {id:this.state.id ,short_name: this.state.short_name, long_name: this.state.long_name}
    this.sendApi(data)
  }

  sendApi = group => {
    UserGroupStore.save(group).then(r => {
      this.setState({ saveMessage: 'Grupo guardado con éxito', showMessage: true, type: 'saved' });
      if (r.data.id !== this.state.id) {
        this.setState({ id: r.data.id, saveMessage: 'El grupo se creó exitosamente', showMessage: true, type: 'success' });
        this.props.onChange({ ...group, id: r.data.id});
        this.setState({users_section: true})
      }
    })
    .catch((error) => {
      this.setState({showMessage: true, type: 'info'})
      const name_e = error.response.data.short_name;
      const desc_e = error.response.data.long_name;
      let msj = '';

      if(name_e !== undefined)
      msj = name_e[0]

      if(desc_e !== undefined)
      msj = desc_e[0]

      switch(msj){
        case 'has already been taken':
          this.setState({saveMessage: 'Ya existe un grupo con ese nombre'})
          break;
        case "can't be blank":
          this.setState({saveMessage: 'Campos requeridos'})
          break;
        default:
          this.setState({saveMessage: 'Error'})
          break;
      }
    })
  };

  onClose = e => {
    if(this.state.showMessage === true){
        this.onChangeName(this.state.current_name,'short_name');
    }
    this.setState({ saveMessage: '', showMessage: false });
    const { group, onClose } = this.props;
    if (group.id !== this.state.id)
      onClose(e, { type: "new", old_id: group.id, new_id: this.state.id });
    else if (this.state.id === 0) onClose(e, { type: "cancel" });
    else onClose(e, { type: "update" });
  };

  onUserAdded = () => {
    this.setState({
      saveMessage: 'El usuario se agregó con éxito',
      showMessage: true,
      type: 'success'
    })
  }

  onUserDeleted = () => {
    this.setState({
      saveMessage: 'El usuario se eliminó con éxito',
      showMessage: true,
      type: 'info'
    })
  }

  onUserAddedFailed = (m) => {
    this.setState({
      saveMessage: m,
      showMessage: true,
      type: 'info'
    })
  }

  render() {
    const { short_name, long_name, users_section, id, type, showMessage, saveMessage } = this.state;
    const { open, classes, readOnly } = this.props;
    const id_invalid = (id === 0 || id === null);
    const valid = ((long_name !== '') && (short_name !== ''))? false : true;
    return (
      <React.Fragment>
        <Dialog
          open={open}
          onClose={this.onClose}
          maxWidth="md"
          fullWidth
          disableBackdropClick
          scroll='paper'
        >
          <DialogTitle id="form-dialog-title">
            {readOnly? 'Información del grupo' : id_invalid? 'Crear Grupo' : 'Editar Grupo' }
            <IconButton onClick={this.onClose} className={classes.close}>
              <CloseIcon/>
            </IconButton>
            <Grid container spacing={8}>
              <Grid item lg={3} sm={3} xs={12}>
                <TextField
                  disabled={readOnly}
                  error={valid}
                  margin="normal"
                  variant="outlined"
                  label="Nombre"
                  value={short_name}
                  fullWidth
                  onChange={e => {
                    this.onChangeName(e.target.value, "short_name");
                  }}
                  InputProps={{
                    classes: { input: classes.placeholder }
                  }}
                />
              </Grid>
              <Grid item lg={9} sm={9} xs={12}>
                <TextField
                  disabled={readOnly}
                  error={valid}
                  margin="normal"
                  variant="outlined"
                  label="Descripción"
                  value={long_name}
                  multiline
                  onChange={e => {
                    this.onChangeName(e.target.value, "long_name");
                  }}
                  rowsMax="4"
                  fullWidth
                  className={classes.placeholder}
                  InputProps={{
                    classes: { input: classes.placeholder }
                  }}
                />
              </Grid>
            </Grid>
          </DialogTitle>

          {id_invalid? null
            :
            <DialogContent style={{minHeight: 137, maxHeight: 295, overflowY: 'scroll'}}>
            <Grid container spacing={8}>
              <Grid item lg={12} sm={12} xs={12}>
                <UserList
                  group_id={id}
                  disabled={readOnly? true : id_invalid? !users_section : false}
                  onUserAdded={this.onUserAdded}
                  onUserAddedFailed={this.onUserAddedFailed}
                  onUserDeleted={this.onUserDeleted}
                />
              </Grid>
            </Grid>
          </DialogContent>}
          <DialogActions className="dialog-buttons">
              <MessageAction show={showMessage} type={type} message={saveMessage} />
              <Button onClick={this.onCreate} color="primary" className="button_modal_medium" disabled={valid || readOnly}>
                {id_invalid? 'Crear Grupo' : 'Guardar Grupo'}
              </Button>
          </DialogActions>
        </Dialog>
      </React.Fragment>
    );
  }
}

class UserList extends AbstractUserList {
  getStore() {
    UserGroupStore.setGroup(this.props.group_id);
    return UserGroupStore;
  }
}
UserGroupDetail.propTypes = {
  group: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired
};
export default withStyles(style)(UserGroupDetail);



// WEBPACK FOOTER //
// ./src/components/UserGroupDetail.js